import StoryBooks, {StoryBook} from "../data/StoryBooks";
import "./StoryLibrary.css"
import {useParams} from "react-router";
import {Link} from "react-router-dom";

export const StoryFocus: React.FC = () => {
    const { storyKey } = useParams<{ storyKey: string }>();

    let story = StoryBooks.find(s => s.id === storyKey) as StoryBook;

    return (
        <div className="root">

            <Link to="/">&lt; Back to library </Link>
            <div>
                <h2 className="text-center mt-4 fw-bold">{story?.title}</h2>

                <div className="float-end">
                    <img src={`/bookcovers/${storyKey}.png`} className="bookcover" alt={story?.title}/>
                </div>
                <div>Tags:&nbsp;
                    {story.tags.map(t => <><span className="badge badge-pill badge-primary">{t}</span>&nbsp;</>)}
                </div>
                <div>{story?.description
                    ?.split(".")
                    .filter(s => s.trim().length > 0)
                    .map((sentence, i) => (
                        <div key={i}>{sentence.trim()}.</div>
                    ))}</div>
                <div className="clearfix">
                    &nbsp;
                </div>
                <Link to={"/play/"+storyKey} className="btn btn-dark d-block m-4">Play</Link>
            </div>
        </div>
    );
};
